import { handleLocalStorage } from './handleLocalStorage'

type GetProductNoteFunctionType = (
  productId: number,
  categoryId: number
) => string | undefined

export const getProductNote: GetProductNoteFunctionType = (
  productId: number,
  categoryId: number
) => {
  const productsNotes = handleLocalStorage('products_notes')
  return productsNotes?.[`${categoryId || 0}_${productId || 0}`]
}
